import React, { StrictMode, useEffect } from 'react';

import { useRouteError } from 'react-router-dom';

import routes from 'app/routes';

import axios from 'axios';

export default function ErrorBoundary() {
  const error = useRouteError();

  const currentPath = window.location.pathname;

  const sendErrorToAPI = () => {
    axios
      .post(routes.api.errors, {
        error: {
          message: error.message || 'Unknown Error',
          stack: error.stack || 'No stack trace',
          route: currentPath, // Include route where the error happened
          time: new Date().toISOString(),
        },
      });
  };

  useEffect(() => {
    if (error) {
      sendErrorToAPI();
    }
  }, [error]);

  return (
    <StrictMode>
      <div className="content text-center">
        <h1 className="pt-5">Oops! Something Unexpected Happened</h1>
        <p className="pt-3 pb-5">
          Don&apos;t worry - we&apos;re here to help!
          Please reach out to our support team and we&apos;ll get you back on track right away.
        </p>
      </div>
    </StrictMode>
  );
}
